import { RHFAutocomplete } from "@/src/components/hook-form";

import { useMemo } from "react";
import { CustomButton } from "@/src/lib/ui";
import { useFormContext } from "react-hook-form";
import { GENDER } from "@/src/lib/module-helper";

import { useEffect } from "react";

const PatientDropDown = ({ onAddPatient, patients }) => {
    const { reset, setValue } = useFormContext();

    useEffect(() => {
        if (patients?.length > 0) {
            reset({
                firstName: patients[0].pName,
                gender: GENDER[0],
                email: patients[0].email,
                mobile: patients[0].mobile,
                dob: patients[0].dob,
            });
            setValue("patient", patients[0], { shouldValidate: true });
            setValue("pid", patients[0].patientId, { shouldValidate: true });
        }
    }, [patients, reset, setValue]);

    return (
        <div className="sticky top-16 md:top-28 z-20 mb-5 flex justify-between items-center shadow p-4 border border-gray-200 bg-white">
            <div>
                <p className="text-xs font-semibold text-gray-700 mb-1 uppercase tracking-widest md:block hidden">
                    Select Patient
                </p>

                <RHFAutocomplete
                    size="small"
                    name="patient"
                    label="Select Patient"
                    options={patients || []}
                    getOptionLabel={(option) => option.pName}
                    isOptionEqualToValue={(option, value) =>
                        option.patientId === value.patientId
                    }
                    onChange={(_, value) => {
                        if (!value) return;

                        const gender = GENDER.find(
                            (item) =>
                                item.value.toLowerCase() ===
                                value.gender.toLowerCase()
                        );
                        reset({
                            firstName: value.pName,
                            gender: gender || GENDER[0],
                            email: value.email,
                            mobile: value.mobile,
                            dob: value.dob,
                        });
                        // Ensure PID is explicitly set for registered fields
                        setValue("pid", value.patientId, {
                            shouldValidate: true,
                            shouldDirty: true,
                        });
                        setValue("patient", value, { shouldValidate: true });
                    }}
                />
            </div>

            <CustomButton
                variant="outlined"
                color="primary"
                onClick={onAddPatient}
                className="hover:bg-primary hover:text-white md:text-sm text-xs "
            >
                Add Patient
            </CustomButton>
        </div>
    );
};

export default PatientDropDown;
